var map = {
	"./_template.json": [
		"../locale/res/translations/_template.json",
		"locale_res_translations__template_json"
	],
	"./de.json": [
		"../locale/res/translations/de.json",
		"locale_res_translations_de_json"
	],
	"./es.json": [
		"../locale/res/translations/es.json",
		"locale_res_translations_es_json"
	],
	"./fr.json": [
		"../locale/res/translations/fr.json",
		"locale_res_translations_fr_json"
	],
	"./it.json": [
		"../locale/res/translations/it.json",
		"locale_res_translations_it_json"
	],
	"./mk.json": [
		"../locale/res/translations/mk.json",
		"locale_res_translations_mk_json"
	],
	"./pl.json": [
		"../locale/res/translations/pl.json",
		"locale_res_translations_pl_json"
	],
	"./ru.json": [
		"../locale/res/translations/ru.json",
		"locale_res_translations_ru_json"
	],
	"./tr.json": [
		"../locale/res/translations/tr.json",
		"locale_res_translations_tr_json"
	],
	"./tw.json": [
		"../locale/res/translations/tw.json",
		"locale_res_translations_tw_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "../locale/res/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;